import { ModuleNode } from '../types';
import { hideIBPExec, hideMDIPExec } from '../../../service/config';

export const programExecutiveModule: ModuleNode = {
  key: 'programExecutive',
  title: 'Program Executive',
  submodules: [
    ...(hideIBPExec
      ? []
      : [
          {
            key: 'ibp',
            title: 'Integrated Business Planning (IBP)',
            route: '/dashboard/programExecutiveLanding',
            pages: [
              {
                key: 'ibp-jobs-monitoring',
                title: 'IBP Jobs Monitoring',
                route: '/ibp/dashboard',
                items: [],
              },
              {
                key: 'ibp-executive-dashboard',
                title: 'IBP Executive Dashboard',
                route: '/ibp/executive',
                items: [
                  {
                    key: 'monitoring',
                    label: 'Monitoring',
                    tags: ['monitoring', 'cost', 'platform', 'quality', 'GDOs', 'jobs'],
                  },
                ],
              },
              {
                key: 'bdr-dashboard',
                title: 'BDR Dashboard',
                route: '/ibp/bdr-pbi',
                items: [],
              },
            ],
          },
        ]),

    ...(hideMDIPExec
      ? []
      : [
          {
            key: 'mdip-executive',
            title: 'MDIP Executive Dashboard',
            route: '/mdip/dashboard',
            pages: [
              {
                key: 'mdip-executive-dashboard',
                title: 'MDIP Executive Dashboard',
                route: '/mdip/dashboard',
                items: [],
              },
              {
                key: 'mdip-job-dashboard',
                title: 'MDIP Job Dashboard',
                route: '/mdip/job',
                items: [],
              },
            ],
          },
        ]),
  ],
};
